var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "emd-tabbar jsTabbar _bordered" }, [
        _c("ul", { staticClass: "emd-tabbar__list" }, [
          _c("li", { staticClass: "emd-tabbar__item" }, [
            _c(
              "a",
              {
                staticClass: "emd-tabbar__link",
                class: { _active: _vm.tabActive === "info" },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("info")
                  },
                },
              },
              [
                _c("span", { staticClass: "emd-text" }, [
                  _vm._v(_vm._s(_vm.$t("plan.detail.tab-info"))),
                ]),
              ]
            ),
          ]),
          _vm.permissionIsEnabled("subscription:search")
            ? _c("li", { staticClass: "emd-tabbar__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-tabbar__link",
                    class: { _active: _vm.tabActive === "subscriptions" },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("subscriptions")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text" }, [
                      _vm._v(_vm._s(_vm.$t("plan.detail.tab-subscriptions"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.tabActive === "info" ? _c("plan-info") : _vm._e(),
      _vm.tabActive === "subscriptions" ? _c("plan-subscriptions") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }